var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.116,
    height: 22.721,
    viewBox: "0 0 21.116 22.721",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#d4d4d4;fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-201.215 -218.431)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M203.1,223.067h-1.889v-1.635h.835c1.674,0,3.349-.019,5.023.011.512.009.658-.16.634-.652-.036-.774-.01-1.551-.01-2.359h7.821V221.4h6.812v1.641h-2.149c-.469,6.076-.931,12.075-1.4,18.107H204.5C204.035,235.136,203.573,229.137,203.1,223.067Zm1.614.01,1.255,16.425h11.26l1.274-16.425Zm9.179-3.032h-4.523v1.282H213.9Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M295.794,270.056l1.63.079-.645,11.874-1.63-.079C295.365,277.954,295.577,274.06,295.794,270.056Z",
    transform: "translate(-81.345 -44.707)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M246.154,281.958c-.213-3.968-.422-7.857-.636-11.848l1.611-.085c.054.8.113,1.549.153,2.3q.232,4.374.453,8.749c.043.853.038.855-.841.884C246.673,281.965,246.452,281.958,246.154,281.958Z",
    transform: "translate(-38.366 -44.68)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M273.073,270.413H274.6v11.835h-1.531Z",
    transform: "translate(-62.228 -45.016)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.eefb02dd2a0aa8e3bf4035ee765946c9.svg";
export { ForwardRef as ReactComponent };